'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (config) {
  config.adyenSdk.js = {
    url: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.16.0/adyen.js',
    integrity: 'sha384-eOf0O1MTPGB1DQpr+Yha0MrmJruQb5S82+tuyo4sLiyfo1hgbf6W+fNfLjjU7Sks'
    // url: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.9.0/adyen.js',
    // integrity: 'sha384-aEL1fltFqDd33ItS8N+aAdd44ida67AQctv9h57pBGjNJ8E2xxbX/CVALJqO8/aM'
  };

  config.adyenSdk.css = {
    url: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/5.16.0/adyen.css',
    integrity: 'sha384-zy4t7axSdzHBMGqwJAynlv3eFVNiWw68LMf7vgKXxl2zZ6A8FlpucOoA/J//GBaQ'
    // url: 'https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.9.0/adyen.css',
    // integrity: 'sha384-0IvbHDeulbhdg1tMDeFeGlmjiYoVT6YsbfAMKFU2lFd6YKUVk0Hgivcmva3j6mkK'
  };

  config.app.prometheusStores.eukdlx.adyenPublicKey = '10001|DE3A27CF8E258CF95955CA2CFAD5CE' + '5BE856005AEA227712D1DB649EA47BBB6F9802BB2EF8784A7C697DDE60627FE98923DA5810A6B1673F1A9AD' + '2139C6207CB8982E6E203321C2850F464C18E860B435248C9AC4FD4B30B38A4DBAC49655AF9811828068726' + 'D986017167BDFC342EF979FC9ED4E5737250FF88F9070AC0D01E3EB7DFC135AF3F6181A809054DB25786742' + 'CFC4111DCC83FB2F1E677177B54FD339D71248CC16160F64E81984DAAEB2101FE1B00EF8FCCF065CFABE6F7' + 'AD56256497E1ABD767E4478FF9CA4BBAAC83D84CB7FFB9867DD3840840A8E645E6CE1F67BAB176C2791119F' + 'DD81E2BB5C804A80D2D3966E883BFDBAA9B6145DFCAEDD3';

  config.app.prometheusStores.eukher.adyenPublicKey = '10001|D2AC2C127A9517BA39960FA6EBCA484F8' + '9866359D87AF22C735670E06CE0E2AA08437147455DC4FD45291D908D01979951377889291563C0BE9752B5' + '8B31E632B7B8CDB5FC48183C8AAFADACA3ACD141891CDB31DC8E77CDB728EB0686E96523DE2C988B9FA0AAB' + '6FA9BE2F355BF2CF4C7333D5D358A2D30E0B799F5BD554DDDD382B319D826854AA2A7215DB9293DB88C9C22' + '233FCC2A32FC5CBD743FE4A8DCCCD946219C8B5EE676060A616CD644A0A958CFD258C410FBBAC5D84426B83' + 'F35FE536A22F46A30CC4F0B73AF5C6CC26B4398EE8FDDBE94CB7455985E2671754EDB532F7F313FB94AA9C5' + '92131D2567CBDBA2E593650AF567F55C7636079B25B9';

  config.app.prometheusStores.efrdxv.adyenPublicKey = '10001|C605E5FDF6B443E4D81E500E1671C68B2' + '430B18E03A24FF187279386E9D5EB64511E7C6F509A11FEBE09D0037978A8C1C3FCCCAFAD3E5FDCE59878C5' + '11FE6D0B912AAA957CF4834000B1B4E403717AB9308F465D47F5CCEB3874DDCA23E17914E90E31A31996463' + '1B05D955A46ADB35DF4587C74848DD11B881DD42F3506CC85AB480DEA7E4912475F2F2B8F4C054D63E62557' + 'BF2882C96CC0FA651F5DA303748BF7D0A3491A99333D88CAAE1222EF3411938A4ADDFCF7881F62D6F16509F' + '2E001BCA481BA0D18923E3097C90304315A9E3D002673AA0DF62740E410C994A69A7C11A54A38C1D8786CF9' + '288F6C714C57FE93C6F8E1A21B4DE5693BF4C3122B2F';

  config.app.prometheusStores.enlflx.adyenPublicKey = '10001|CE331A50C3DB0E61B10E342ED7CFB9684' + '9BA49C2F15F07AA5CAD42C38CE94C29E98A812DC7D5FB371ABE4207C887ED791F99AECE73D1CDA19909197C' + '5A5A12FE556204BBC9EFD436F20BD182C1D94A481A8C52266CC1D224D118E17AC2B896EB83E6CF46B082052' + 'B47BEF2EEC0DE81D18D63959050C1DF7A4F1609596401F1F3E13789D2CD1DB90B63EBA3028FE443650F5AEF' + 'C86482E8B672A124EDBE6819B3B640511F7E3B8A4FE9250988EC236A2B099D2C4646C4269B6CDE657DE5ADD' + 'C191D83CB47D76A06E49EFDEAFAAD82D2DD7025A18F4398209C9A6108465729B2C1902A85ED3CD72E3F93C8' + '88BEA8EFAA63812313232C7FD26F6F833B723CC306ED';

  config.app.prometheusStores.ebelev.adyenPublicKey = '10001|B7224E31F71FAEB3C4DFE1D316CFCB1' + '695499A006F9678A602C3690B5007DC41CC2A3E29588F88B5AF8FFE7853416C8E240502C48CB797A1B06005' + '81665DF6ABCEC2C06408C28BFA953381E158C937CF65EEE954E6E2DAFAF2FD7B84EDF141E8271CDD901F0BC' + 'EB5A1097FA517CD39EBF322F7171696718F1C81DAA238934ED7AF5B9E375370CE5DEDB7EBF5A38B571B3AEA' + '9C002374F72A7E67D893B8454A5E2C6048A37A46BE732950EB79C957F501B4E0B91CD6C63322A2EBE0D24CC' + '767C867C41A97DB7AD1F06C3A69B926DB2DD48510EC7A088F3D9CC7CC8CD2E25982AAB8B49A877441F8F4D4' + '81F343BADDF71A73F96CBF14FD70DD871DA230D16FC777';

  config.app.prometheusStores.levisletscolour.adyenPublicKey = '10001|B7224E31F71FAEB3C4DFE1D3' + '16CFCB1695499A006F9678A602C3690B5007DC41CC2A3E29588F88B5AF8FFE7853416C8E240502C48CB797A' + '1B0600581665DF6ABCEC2C06408C28BFA953381E158C937CF65EEE954E6E2DAFAF2FD7B84EDF141E8271CDD' + '901F0BCEB5A1097FA517CD39EBF322F7171696718F1C81DAA238934ED7AF5B9E375370CE5DEDB7EBF5A38B5' + '71B3AEA9C002374F72A7E67D893B8454A5E2C6048A37A46BE732950EB79C957F501B4E0B91CD6C63322A2EB' + 'E0D24CC767C867C41A97DB7AD1F06C3A69B926DB2DD48510EC7A088F3D9CC7CC8CD2E25982AAB8B49A87744' + '1F8F4D481F343BADDF71A73F96CBF14FD70DD871DA230D16FC777';

  config.app.prometheusStores.ebewdc.adyenPublicKey = '10001|A6CE63D010469D990D195FC67AAB9BFB7' + '8D95A99845779DB697910C29EC644489CAC7D54572A2461F7E7F060AC440EBBE761EA2C8FB0071D8A4AF0DF' + 'BE22F1DA2ABA2D6C7FB7858620831DCBAAF248BBC4E4678B620751EA7BC223A0615237A2A2E38A1CB679C28' + '58AA807049B16F9DEC81925E8EA94EC9E9C3FE18C2EF0CD04ED2332C763EF13B45370FF8FADA016B2924F18' + '558E319643D8D71CD76D6960EAB81259971944F44437D1EDD4BDE40A4F5BD3A42A6640E5C4317C45854E394' + '3BCF890FF548311054FFFF6B7EC9B341174294601898350233052B343D7A3F37CC046024E89E9F9C90A1787' + '77386BE9CE36C49332AB8789DDFE430F615EDDAB526F';

  config.app.prometheusStores.enlwdc.adyenPublicKey = '10001|CBCF01A2238E6F08B68ACDC6206A44BDF' + '680CF6AB426E3EE392DDF6DF64F86CA0F89540E620B0BDC3510F6C4CC32CC3E23CC67F1C1BE2AC61C3695F0' + 'B021AB91B35FEC9888571A8E7902CD66EB17B73C58673FDC85DA42B840B641643888BBF03E60A8B61868E25' + '0BEA9F3E52E2F44F40E59FE3A0091EE393B8D677D575C7DE8E731C56FBD19CEF0AFE60D4611A5907DC2593A' + 'F7480A71CA463495E72B24BD8801E089CE14AFF7D0315D387FDE56A04F7A0118CA77702A4CE90186DA03ACC' + '650C2C623BD9E08C4EE97E9EFDD09562A9408A85697D77C8E4E9402780484DEACC8CE850EC736F31C23B381' + 'B69FF6080D4000F4187406B28192350865B0B62D93E3';

  config.app.prometheusStores.eiedlx.adyenPublicKey = '10001|9D17E2B6A6B8D787C5942CD3AF9D6FFED' + 'C4E5F2B703EE58CB91E9BBD17AB2CBC9C131BDC333098E20A86268B72DA7293DF0BF50F20933BDCB74A61C6' + '5D3A57B5F0F63620AEA2491D8CE8B3809167FAF976A1CDEF2B472E1C404551F1B6DD5DD5D555F6B3508EF86' + '005D851ACE13A1CC4C7E251E442B999BE9E9524AF9C96B298AD9B8C0F3C1BCEB8183C745642C3E1156171D7' + '95B9E5875761834F949E1563BD35E51CA92C66ED67A7F0FF526B5F98971A2CC5C33915605F3526C34BDD7EC' + '8BF5C5862AC1559299C53AF5F17DD74543966986FD663969C92A0D9516EB38859018EFF03E5ECD899F7C791' + '9B0D384E35CDBDA761D99176723B46A3E5FF6ED06581';

  config.app.head.script = [{
    src: 'https://cdn.ravenjs.com/3.10.0/raven.min.js',
    crossorigin: 'anonymous'
  }];

  config.app.prometheusStores.eukdlx.askSid = {
    enabled: true,
    src: 'https://api.asksid.ai/akzo-webchat/wc.min.js'
  };

  config.app.prometheusStores.enlflx.askSid = {
    enabled: true,
    src: 'https://api.asksid.ai/akzo-webchat-enlflx/wc.min.js'
  };

  config.app.prometheusStores.enlwdc.askSid = {
    enabled: true,
    src: 'https://api.asksid.ai/akzo-webchat-enlwdc/wc.min.js'
  };

  config.app.prometheusStores.ebelev.askSid = {
    enabled: true,
    src: 'https://api.asksid.ai/akzo-webchat-ebelev/wc.min.js'
  };

  config.app.prometheusStores.efrdxv.askSid = {
    enabled: true,
    src: 'https://api.asksid.ai/akzo-webchat-efrdxv/wc.min.js'
  };

  config.app.prometheusStores.eukdlx.visualWebsiteOrganizer = {
    enabled: true,
    accountId: '268080'
  };

  config.app.prometheusStores.enlflx.visualWebsiteOrganizer = {
    enabled: true,
    accountId: '268110'
  };

  config.app.prometheusStores.ebelev.visualWebsiteOrganizer = {
    enabled: true,
    accountId: '268098'
  };

  config.app.prometheusStores.levisletscolour.visualWebsiteOrganizer = {
    enabled: true,
    accountId: '268098'
  };

  config.app.prometheusStores.efrdxv.visualWebsiteOrganizer = {
    enabled: true,
    accountId: '268104'
  };

  config.app.prometheusStores.eukdlx.launchTagManager.oneTrustConsentDomainScript = '274f8f0f-2e1a-462d-8dab-73a2431aff25';
  config.app.prometheusStores.eukexp.launchTagManager.oneTrustConsentDomainScript = '60ae2078-6de1-4cbb-b0be-337dd85a9d4a';
  config.app.prometheusStores.enlflx.launchTagManager.oneTrustConsentDomainScript = 'd7b8c4e4-7217-43d7-95a9-739d340285e8';
  config.app.prometheusStores.ebelev.launchTagManager.oneTrustConsentDomainScript = '9f70b625-69ea-4ab9-b501-10c4ef6ab08b';
  config.app.prometheusStores.levisletscolour.launchTagManager.oneTrustConsentDomainScript = '9f70b625-69ea-4ab9-b501-10c4ef6ab08b';
  config.app.prometheusStores.ebewdc.launchTagManager.oneTrustConsentDomainScript = 'a17bf310-d50b-4e25-8848-4a2df69dfec3';
  config.app.prometheusStores.enlwdc.launchTagManager.oneTrustConsentDomainScript = '352557b0-1cea-4b04-9f97-71b03f916fa5';
  config.app.prometheusStores.eiedlx.launchTagManager.oneTrustConsentDomainScript = 'f27ef959-6169-4fd1-9608-8dac14b25035';
  config.app.prometheusStores.efrdxv.launchTagManager.oneTrustConsentDomainScript = '326adb25-0e49-4b01-a266-dd7d58311577';

  config.launchEmbedCode = '//assets.adobedtm.com/feb986e74bf7/f95cb7da5d29/launch-532cb729038f.min.js';
  config.oneTrustConsentEmbedCode = '//cdn.cookielaw.org/scripttemplates/otSDKStub.js';

  config.app.prometheusStores.eukdlx.adyenCheckout.clientKey = 'live_T46FJ3DOPRDOVOZLV2ZEZ77KFU6NHZRI';
  config.app.prometheusStores.eukher.adyenCheckout.clientKey = 'live_E3H2NSOZFZEXBNPPDPZ5EZICBIR6HI4O';
  config.app.prometheusStores.eiedlx.adyenCheckout.clientKey = 'live_WX2NF62FYRF2NIOFF5ZSKOGRJINIV4AZ';
  config.app.prometheusStores.efrdxv.adyenCheckout.clientKey = 'live_GYUUXL2XANGV5FPL6TIZ235IKQ3C34BZ';
  config.app.prometheusStores.enlflx.adyenCheckout.clientKey = 'live_SNREZSQMVFHPHBTSMQXOO2QX4IRL5LKR';
  config.app.prometheusStores.enlwdc.adyenCheckout.clientKey = 'live_LXT4VQY6EFF7RB7DQWC26PKI5YNBZTKU';
  config.app.prometheusStores.ebelev.adyenCheckout.clientKey = 'live_PM57KUEHRZACPCHU633G7PZ6BMGBDKEX';
  config.app.prometheusStores.levisletscolour.adyenCheckout.clientKey = 'live_PM57KUEHRZACPCHU633G7PZ6BMGBDKEX';
  config.app.prometheusStores.ebewdc.adyenCheckout.clientKey = 'live_65ISKWM2SJB3DARZ6JEORM4IF44JTGIQ';

  config.app.prometheusStores.eukdlx.bazaarvoiceTracking = {
    enabled: false,
    loader: 'https://apps.bazaarvoice.com/deployments/dulux_uk/main_site/production/en_GB/bv.js'
  };

  config.app.prometheusStores.efrdxv.bazaarvoiceTracking = {
    enabled: true,
    loader: 'https://apps.bazaarvoice.com/deployments/dulux-fr/main_site/production/fr_FR/bv.js'
  };

  config.app.prometheusStores.eukher.bazaarvoiceTracking = {
    enabled: true,
    loader: 'https://apps.bazaarvoice.com/deployments/heritage-gb/main_site/production/en_GB/bv.js'
  };

  config.app.prometheusStores.enlflx.bazaarvoiceTracking = {
    enabled: false,
    loader: 'https://apps.bazaarvoice.com/deployments/flexa/main_site/production/nl_NL/bv.js'
  };

  config.app.prometheusStores.ebelev.bazaarvoiceTracking = {
    enabled: false,
    loader: 'https://apps.bazaarvoice.com/deployments/levis-akzonobel/main_site/production/nl_BE/bv.js'
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)((0, _values2.default)(config.app.prometheusStores)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var store = _step.value;

      store.adyenCheckout.environment = 'live';
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return config;
};


//////////////////
// WEBPACK FOOTER
// ./config/production/index.js
// module id = 2241
// module chunks = 0